import { render, staticRenderFns } from "./MediaClip.vue?vue&type=template&id=5b277e55&scoped=true"
import script from "./MediaClip.vue?vue&type=script&lang=ts"
export * from "./MediaClip.vue?vue&type=script&lang=ts"
import style0 from "./MediaClip.vue?vue&type=style&index=0&id=5b277e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b277e55",
  null
  
)

export default component.exports